/*
 * Шаги курса слепой печати (/typing-course) на платформе курсов.
 *
 *   type-setup   — раскладка ученика (угадываем через getLayoutMap), проверка F и J;
 *   type-keys    — новые клавиши: палец, место на клавиатуре, строка из них;
 *   type-drill   — упражнение из УЖЕ выученных клавиш: сочетания и настоящие слова;
 *   type-text    — набрать текст урока (тексты — по языкам);
 *   type-test    — набор на время: скорость, точность, ошибки по клавишам;
 *   type-finger  — каким пальцем нажимают эту клавишу;
 *   рисунок keyboard — клавиатура раскладки с зонами пальцев.
 *
 * Урок задан ФИЗИЧЕСКИМИ клавишами (KeyboardEvent.code) в course.json; буквы
 * даёт раскладка (TypingLayouts). Слова — из пула частых слов языка
 * (public/data/typing/course/words-{locale}.json, scripts/build-typing-course-words.mjs),
 * отобранных по выученным клавишам. Слабые клавиши ученика (ошибки по
 * клавишам копятся в api.store) получают в упражнениях больший вес.
 *
 * Клавиатура: пока шаг набора на экране, нажатия принимает он (body[data-kbd-capture],
 * keydown в фазе захвата на window); поле ввода в фокусе где-то ещё — не наше.
 * Ошибочная клавиша курсор не двигает — исправлять нечего, Backspace не нужен.
 * Неверная раскладка или Caps Lock — не ошибка ученика: подсказка и ожидание
 * (KeyboardState). Корейский сверяется по коду клавиши — IME отдаёт 'Process'.
 * Разбор — docs/why/typing-course.md.
 */
(function () {
    'use strict';
    var K = window.CourseKit;
    var TL = window.TypingLayouts;
    if (!K || !TL) return;
    var KS = window.KeyboardState || null;
    var CFG = window.__TYPING_COURSE || {};

    var CASED = { latin: 1, cyrillic: 1 };
    var MOD = { Shift: 1, Control: 1, Alt: 1, Meta: 1, CapsLock: 1, AltGraph: 1, OS: 1, Fn: 1, NumLock: 1, ScrollLock: 1, ContextMenu: 1 };
    var AR_DIGITS = { '٠': '0', '١': '1', '٢': '2', '٣': '3', '٤': '4', '٥': '5', '٦': '6', '٧': '7', '٨': '8', '٩': '9' };

    /* ── раскладка ученика ─────────────────────────────────────────── */
    function layoutId(api) {
        var o = TL.forLocale(api.locale);
        var id = api.store.get('layout', null);
        if (!id || o.options.indexOf(id) < 0) id = o.def;
        return id;
    }
    function layoutName(api, id) { return api.tt('layout_' + id); }
    function fingerName(api, f) { return api.tt('finger_' + f); }
    function isKo(layout) { return layout.script === 'hangul'; }

    /* ── частые слова языка ────────────────────────────────────────── */
    var wordsP = null;
    function loadWords() {
        if (wordsP) return wordsP;
        if (!CFG.wordsUrl) { wordsP = Promise.resolve([]); return wordsP; }
        // Словарь не пришёл за 12 с или пришёл с ошибкой — упражнение собирается
        // из групп букв, а следующий шаг спросит словарь снова (провал не кэшируется).
        var ctl = typeof AbortController === 'function' ? new AbortController() : null;
        var timer = setTimeout(function () { if (ctl) ctl.abort(); }, 12000);
        var failed = function () { wordsP = null; return []; };
        wordsP = fetch(CFG.wordsUrl, ctl ? { credentials: 'same-origin', signal: ctl.signal } : { credentials: 'same-origin' })
            .then(function (r) { if (!r.ok) throw new Error('words ' + r.status); return r.json(); })
            .then(function (d) { clearTimeout(timer); return Array.isArray(d.words) && d.words.length ? d.words : failed(); })
            .catch(function () { clearTimeout(timer); return failed(); });
        return wordsP;
    }

    /* ── случайность, повторяемая внутри шага ─────────────────────── */
    function rng(seed) {
        var a = 0;
        for (var i = 0; i < seed.length; i++) a = (a * 31 + seed.charCodeAt(i)) | 0;
        return function () {
            a = (a + 0x6D2B79F5) | 0;
            var t = Math.imul(a ^ (a >>> 15), 1 | a);
            t = (t + Math.imul(t ^ (t >>> 7), 61 | t)) ^ t;
            return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
        };
    }
    function pick(arr, r) { return arr[Math.floor(r() * arr.length)]; }

    /* ── статистика клавиш ученика ─────────────────────────────────── */
    function statsGet(api) { return api.store.get('keyStats', {}) || {}; }
    function weakCodes(api, allowed, n) {
        var s = statsGet(api), list = [];
        for (var code in s) {
            if (!Object.prototype.hasOwnProperty.call(s, code) || !allowed[code] || code === 'Space') continue;
            var x = s[code];
            if (!x || x.n < 8) continue;
            list.push({ code: code, rate: (x.err || 0) / x.n });
        }
        list.sort(function (a, b) { return b.rate - a.rate; });
        return list.slice(0, n || 4).filter(function (x) { return x.rate > 0.03; }).map(function (x) { return x.code; });
    }

    /* Символы, которые дают клавиши codes (буквы — всегда, Shift-знаки — если shiftOk). */
    function charsOn(layout, codes, shiftOk, lettersOnly) {
        var out = [];
        codes.forEach(function (code) {
            var k = layout.keys[code];
            if (!k) return;
            [k[0]].concat(shiftOk && k[1] !== k[0] ? [k[1]] : []).forEach(function (ch) {
                if (!ch || ch.length !== 1 || out.indexOf(ch) >= 0) return;
                if (lettersOnly && !/\p{L}/u.test(ch)) return;
                out.push(ch);
            });
        });
        return out;
    }
    function allowedMap(codes) {
        var o = { Space: 1 };
        (codes || []).forEach(function (c) { o[c] = 1; });
        return o;
    }

    /* ── генератор упражнений ─────────────────────────────────────── */
    function groups(chars, r, total, minLen, maxLen) {
        var out = [], len = 0;
        while (len < total && chars.length) {
            var n = minLen + Math.floor(r() * (maxLen - minLen + 1)), g = '';
            for (var i = 0; i < n; i++) g += pick(chars, r);
            out.push(g);
            len += g.length + 1;
        }
        return out.join(' ');
    }

    function keyPatterns(focus, known, r, total) {
        // Сначала каждая новая клавиша отдельно, потом в паре, потом со старыми.
        var out = [], len = 0, i;
        focus.forEach(function (c) { var g = c + c + c; out.push(g); len += 4; });
        for (i = 0; i < focus.length - 1; i++) { out.push(focus[i] + focus[i + 1] + focus[i]); out.push(focus[i + 1] + focus[i] + focus[i + 1]); len += 8; }
        var mix = focus.concat(known.slice(-6));
        while (len < total) {
            var n = 2 + Math.floor(r() * 3), g = pick(focus, r);
            for (var k = 1; k < n; k++) g += pick(r() < 0.6 ? focus : mix, r);
            out.push(g);
            len += g.length + 1;
        }
        return out.join(' ');
    }

    function wordPool(words, layout, allowed, shiftOk) {
        var out = [];
        for (var i = 0; i < words.length; i++) {
            if (!TL.typable(words[i], layout, allowed, shiftOk)) continue;
            // Для поиска «новых» букв корейское слово — в чамо (буква урока — ㄹ, а слово — 라면).
            var j = layout.script === 'hangul' ? Array.from(words[i]).map(TL.jamo).reduce(function (a, b) { return a.concat(b); }, []).join('') : words[i];
            out.push({ w: words[i], j: j, rank: i });
        }
        return out;
    }

    function weightedWords(pool, focusChars, weakChars, r, total, top) {
        var src = top ? pool.slice(0, top) : pool;
        if (!src.length) return '';
        var weights = src.map(function (x) {
            var w = 1 / (1 + x.rank / 300);
            var f = 0, k = 0;
            for (var i = 0; i < focusChars.length; i++) if (x.j.indexOf(focusChars[i]) >= 0) f++;
            for (var j = 0; j < weakChars.length; j++) if (x.j.indexOf(weakChars[j]) >= 0) k++;
            return w * (1 + 2.5 * f) * (1 + 3 * k);
        });
        var sum = weights.reduce(function (a, b) { return a + b; }, 0);
        var out = [], len = 0, last = '';
        var guard = 0;
        while (len < total && guard++ < 2000) {
            var x = r() * sum, i = 0;
            for (; i < src.length - 1; i++) { x -= weights[i]; if (x <= 0) break; }
            var w = src[i].w;
            if (w === last && src.length > 3) continue;
            out.push(w);
            last = w;
            len += Array.from(w).length + 1;
        }
        return out.join(' ');
    }

    function capitalize(w) {
        var a = Array.from(w);
        return a.length ? a[0].toLocaleUpperCase() + a.slice(1).join('') : w;
    }

    /* Номера, даты, время, телефоны, суммы — только то, что раскладка набирает. */
    function numberItems(api, layout, r, total) {
        var d2 = function () { var n = 1 + Math.floor(r() * 28); return (n < 10 ? '0' : '') + n; };
        var m2 = function () { var n = 1 + Math.floor(r() * 12); return (n < 10 ? '0' : '') + n; };
        var y = function () { return String(1990 + Math.floor(r() * 40)); };
        var n = function (len) { var s = String(1 + Math.floor(r() * 9)); for (var i = 1; i < len; i++) s += Math.floor(r() * 10); return s; };
        var loc = api.locale;
        var dateFmt = loc === 'en' ? function () { return m2() + '/' + d2() + '/' + y(); }
            : loc === 'ko' ? function () { return y() + '.' + m2() + '.' + d2(); }
            : (loc === 'ru' || loc === 'uk' || loc === 'de') ? function () { return d2() + '.' + m2() + '.' + y(); }
            : function () { return d2() + '/' + m2() + '/' + y(); };
        var makers = [
            dateFmt,
            function () { return d2().replace(/^0/, '1') + ':' + (r() < 0.5 ? '00' : '30'); },
            function () { return '+' + n(1) + ' ' + n(3) + ' ' + n(3) + '-' + n(2) + '-' + n(2); },
            function () { return n(3) + (loc === 'en' || loc === 'ko' || loc === 'ar' ? '.' : ',') + n(2); },
            function () { return n(2) + '%'; },
            function () { return n(4) + ' ' + n(4); },
            function () { return n(1) + n(2); }
        ];
        var out = [], len = 0, guard = 0;
        while (len < total && guard++ < 400) {
            var s = pick(makers, r)();
            if (TL.units(s, layout).length !== Array.from(s).length) continue;
            out.push(s);
            len += s.length + 1;
        }
        return out.join(' ');
    }

    /* Текст урока для этой раскладки: недоступное раскладке — без акцентов или прочь. */
    function fitText(text, layout) {
        var src = String(text || '').replace(/\s+/g, ' ').trim();
        var out = '';
        Array.from(src).forEach(function (ch) {
            if (TL.strokesOf(ch, layout) || ch === ' ') { out += ch; return; }
            var bare = ch.normalize('NFD').replace(/[̀-ͯ]/g, '');
            if (bare !== ch && TL.strokesOf(bare, layout)) out += bare;
        });
        return out.replace(/\s+/g, ' ').trim();
    }

    /* Собрать строку упражнения по описанию шага. */
    function buildText(step, api, layout, words, attempt) {
        var r = rng(step._lesson + '/' + step.id + '/' + attempt + '/' + layout.id);
        var codes = step.keys || [];
        var allowed = allowedMap(codes);
        var shiftOk = !!step.shift;
        var focus = charsOn(layout, step.focus || [], shiftOk, false).filter(function (c) { return c !== ' '; });
        var known = charsOn(layout, codes, false, true);
        // Уроки цифр: клавиша даёт и цифру, и знак (1 и !, на AZERTY — & и 1) — нужна цифра.
        if ((step.focus || []).length && step.focus.every(function (c) { return /^Digit/.test(c); })) {
            focus = focus.filter(function (ch) { return /[0-9]/.test(ch); });
        }
        var total = step.length || 60;
        var mode = step.mode || 'words';
        if (mode === 'text') {
            var t = step.t && step.t.text;
            return fitText(Array.isArray(t) ? t.join(' ') : t, layout);
        }
        if (mode === 'keys') return keyPatterns(focus.length ? focus : known.slice(0, 2), known, r, total);
        if (mode === 'digits') return groups(focus.length ? focus : charsOn(layout, codes, shiftOk, false), r, total, 2, 4);
        if (mode === 'numbers') return numberItems(api, layout, r, total);
        var weak = mode === 'weak' ? weakCodes(api, allowed, 4) : weakCodes(api, allowed, 3);
        var weakChars = charsOn(layout, weak, false, true);
        if (mode === 'weak' && weakChars.length) focus = weakChars;
        if (mode === 'caps' && !CASED[layout.script]) {
            // Заглавных у письма нет (хангыль, арабское): урок Shift — буквы с Shift.
            var lower = charsOn(layout, codes, false, true);
            focus = charsOn(layout, codes, true, true).filter(function (c) { return lower.indexOf(c) < 0; });
        }
        var pool = wordPool(words, layout, allowed, shiftOk);
        var s;
        if (pool.length >= 12) {
            s = weightedWords(pool, focus, weakChars, r, total, mode === 'top' ? Math.min(pool.length, step.top || 100) : 0);
        } else {
            // Слов из выученных клавиш почти нет (первые уроки): сочетания + те слова, что есть.
            var letters = known.length ? known : focus;
            s = groups(letters, r, Math.round(total * (pool.length ? 0.6 : 1)), 2, 4);
            if (pool.length) s += ' ' + weightedWords(pool, focus, weakChars, r, Math.round(total * 0.4), 0);
        }
        if (mode === 'caps' && CASED[layout.script]) {
            s = s.split(' ').map(function (w) { return r() < 0.5 ? capitalize(w) : w; }).join(' ');
            s = fitText(s, layout);
        }
        if (mode === 'sentences' || step.capitals) {
            // После урока Shift: каждое слово после точки — с заглавной.
            var ws = s.split(' '), out = [], newSent = true;
            for (var i = 0; i < ws.length; i++) {
                var w = newSent ? capitalize(ws[i]) : ws[i];
                newSent = false;
                if ((i + 1) % (5 + Math.floor(r() * 4)) === 0 && i < ws.length - 1) {
                    // Арабская раскладка: «،» и «؟» (латинского «?» на ней нет).
                    var mark = pick(layout.script === 'arabic' ? ['.', '.', '،', '؟', '!'] : ['.', '.', ',', '?', '!'], r);
                    // Французская типографика: перед ? ! : ; — пробел.
                    w += (api.locale === 'fr' && /[?!:;]/.test(mark) ? ' ' : '') + mark;
                    newSent = /[.?!]$/.test(w);
                }
                out.push(w);
            }
            s = out.join(' ') + '.';
            s = fitText(s, layout);
        }
        return s;
    }

    /* ── рисунок клавиатуры ───────────────────────────────────────── */
    function keyboard(api, layout, opts) {
        opts = opts || {};
        var el = api.el('div', 'ty-kbd' + (opts.compact ? ' is-compact' : ''));
        el.setAttribute('dir', 'ltr');
        el.setAttribute('aria-hidden', 'true');
        var focus = {};
        (opts.focus || []).forEach(function (c) { focus[c] = 1; });
        var known = opts.known ? allowedMap(opts.known) : null;
        var keyEls = {};
        var rows = TL.rows(layout);
        var lead = [0.45, 0.8, 1.05, 0];
        rows.forEach(function (row, ri) {
            var rowEl = api.el('div', 'ty-row');
            if (ri === 3) {
                var sl = api.el('span', 'ty-key ty-wide f-LP', 'Shift');
                sl.style.flexGrow = row[0] === 'IntlBackslash' ? '1.2' : '2.2';
                keyEls.ShiftLeft = sl;
                rowEl.appendChild(sl);
            } else if (lead[ri]) {
                var sp = api.el('span', 'ty-gap');
                sp.style.flexGrow = String(lead[ri]);
                rowEl.appendChild(sp);
            }
            row.forEach(function (code) {
                var f = TL.finger(code);
                var k = api.el('span', 'ty-key f-' + f);
                k.textContent = TL.label(layout, code, false);
                if (code === 'KeyF' || code === 'KeyJ') k.classList.add('is-bump');
                if (focus[code]) k.classList.add('is-focus');
                if (known && !known[code] && !focus[code]) k.classList.add('is-dim');
                keyEls[code] = k;
                rowEl.appendChild(k);
            });
            if (ri === 2) { var en = api.el('span', 'ty-gap'); en.style.flexGrow = '1.3'; rowEl.appendChild(en); }
            if (ri === 3) {
                var sr = api.el('span', 'ty-key ty-wide f-RP', 'Shift');
                sr.style.flexGrow = row[row.length - 1] === 'IntlRo' ? '1.6' : '2.6';
                keyEls.ShiftRight = sr;
                rowEl.appendChild(sr);
            }
            el.appendChild(rowEl);
        });
        var sp = api.el('div', 'ty-row');
        var g1 = api.el('span', 'ty-gap'); g1.style.flexGrow = '3.5';
        var space = api.el('span', 'ty-key ty-space f-TH', '');
        space.style.flexGrow = '6';
        var g2 = api.el('span', 'ty-gap'); g2.style.flexGrow = '3.5';
        sp.appendChild(g1); sp.appendChild(space); sp.appendChild(g2);
        keyEls.Space = space;
        el.appendChild(sp);
        var lit = [];
        return {
            el: el,
            show: function (codes) {
                lit.forEach(function (x) { x.classList.remove('is-next'); });
                lit = [];
                (codes || []).forEach(function (c) {
                    var k = keyEls[c];
                    if (k) { k.classList.add('is-next'); lit.push(k); }
                });
            }
        };
    }

    function legend(api) {
        var box = api.el('div', 'ty-legend');
        ['LP', 'LR', 'LM', 'LI', 'TH', 'RI', 'RM', 'RR', 'RP'].forEach(function (f) {
            var s = api.el('span', 'ty-leg f-' + f, fingerName(api, f));
            box.appendChild(s);
        });
        return box;
    }

    K.figure('keyboard', function (box, fig, step, api) {
        var layout = TL.get(layoutId(api));
        box.classList.add('ty-fig');
        var kb = keyboard(api, layout, { focus: fig.keys || [], known: fig.known || null });
        box.appendChild(kb.el);
        if (fig.legend) box.appendChild(legend(api));
    });

    /* ── «нужна клавиатура» ───────────────────────────────────────── */
    function coarse() {
        try { return window.matchMedia('(pointer: coarse)').matches && !window.matchMedia('(any-pointer: fine)').matches; } catch (_) { return false; }
    }

    /* Пока шаг набора на экране, клавиатура его: соглашение сайта body[data-kbd-capture]. */
    function captureKeys(api, handler) {
        var editableElsewhere = function () {
            var a = document.activeElement;
            if (!a || a === document.body) return false;
            if (a.isContentEditable) return true;
            var tag = String(a.tagName || '').toUpperCase();
            return tag === 'INPUT' || tag === 'TEXTAREA' || tag === 'SELECT';
        };
        var on = function (e) {
            if (!api.alive()) return;
            if (e.ctrlKey || e.metaKey) return;
            if (e.altKey && !(e.getModifierState && e.getModifierState('AltGraph'))) return;
            if (MOD[e.key] || e.key === 'Tab' || e.key === 'Escape') return;
            var composing = e.isComposing || e.keyCode === 229;
            if (composing) { if (editableElsewhere()) return; }
            else if (window.__keyOwnedByFocus && window.__keyOwnedByFocus(e)) return;
            e.preventDefault();
            e.stopPropagation();
            handler(e);
        };
        window.addEventListener('keydown', on, true);
        try { document.body.setAttribute('data-kbd-capture', 'typing-course'); } catch (_) {}
        var off = function () {
            window.removeEventListener('keydown', on, true);
            try { if (document.body.getAttribute('data-kbd-capture') === 'typing-course') document.body.removeAttribute('data-kbd-capture'); } catch (_) {}
        };
        api.onCleanup(off);
        return off;
    }

    function fmtTime(s) {
        s = Math.max(0, Math.round(s));
        return Math.floor(s / 60) + ':' + ('0' + (s % 60)).slice(-2);
    }
    function speedLine(api, layout, cpm) {
        if (isKo(layout)) return api.tt('speed_ko', { n: Math.round(cpm) });
        var w = Math.round(cpm / 5);
        return (api.locale === 'ru' || api.locale === 'uk')
            ? api.tt('speed_cpm_first', { cpm: Math.round(cpm), wpm: w })
            : api.tt('speed_wpm_first', { cpm: Math.round(cpm), wpm: w });
    }

    /* ── движок набора ────────────────────────────────────────────── */
    /* opts: {text, seconds, minAcc, minCpm, blind, focus, regen()} → answer() */
    function runTyping(host, step, api, layout, opts) {
        var t = step.t || {};
        var box = api.el('div', 'ty-box');
        host.appendChild(box);

        var bar = api.el('div', 'ty-stats');
        var sTime = api.el('span', 'ty-stat');
        var sSpeed = api.el('span', 'ty-stat');
        var sAcc = api.el('span', 'ty-stat');
        bar.appendChild(sTime); bar.appendChild(sSpeed); bar.appendChild(sAcc);
        box.appendChild(bar);

        var textEl = api.el('div', 'ty-text');
        textEl.tabIndex = -1;
        textEl.setAttribute('aria-label', api.tt('text_aria'));
        var dDone = api.el('span', 'ty-done'), dCur = api.el('span', 'ty-cur'), dRest = api.el('span', 'ty-rest');
        textEl.appendChild(dDone); textEl.appendChild(dCur); textEl.appendChild(dRest);
        box.appendChild(textEl);

        var startNote = api.el('p', 'ty-start', api.tt('start_hint'));
        box.appendChild(startNote);
        var hint = api.el('p', 'ty-hint');
        hint.setAttribute('aria-live', 'polite');
        box.appendChild(hint);
        var notice = api.el('p', 'ty-notice');
        notice.hidden = true;
        box.appendChild(notice);

        var kb = keyboard(api, layout, { focus: opts.focus || [], known: step.keys && step.keys.length ? step.keys : null });
        var kbWrap = api.el('div', 'ty-kbd-wrap');
        kbWrap.appendChild(kb.el);
        box.appendChild(kbWrap);
        var blind = !!opts.blind;
        var blindBtn = null;
        if (opts.blind != null) {
            blindBtn = api.el('button', 'lg-btn lg-btn-ghost lg-btn-sm ty-blind');
            blindBtn.type = 'button';
            blindBtn.addEventListener('click', function () { blind = !blind; paintBlind(); try { textEl.focus({ preventScroll: true }); } catch (_) {} });
            box.appendChild(blindBtn);
        }
        function paintBlind() {
            kbWrap.hidden = blind;
            if (blindBtn) blindBtn.textContent = blind ? api.tt('kbd_show') : api.tt('kbd_hide');
        }
        paintBlind();

        var units = TL.units(opts.text, layout);
        var idx = 0, sub = 0, deadArmed = false;
        var good = 0, bad = 0, strokesDone = 0, charsDone = 0;
        var errFlag = false, started = 0, ended = false, lastAt = 0;
        var gaps = [];
        var perKey = {};
        var ticker = null, deadline = 0;
        var touch = coarse();
        var gotKey = false;

        function cur() { return units[idx] || null; }
        function stroke() { var u = cur(); return u ? u.strokes[sub] : null; }

        function render() {
            var done = '', rest = '';
            for (var i = 0; i < idx; i++) done += units[i].ch;
            for (var j = idx + 1; j < units.length; j++) rest += units[j].ch;
            var u = cur();
            dDone.textContent = done;
            dCur.textContent = u ? (u.ch === ' ' ? '␣' : u.ch) : '';
            dCur.className = 'ty-cur' + (errFlag ? ' is-err' : '') + (u && u.ch === ' ' ? ' is-space' : '') + (sub > 0 ? ' is-part' : '');
            dRest.textContent = rest;
            // Строка с курсором — в окне текста (прокрутка ВНУТРИ блока, не страницы).
            try {
                var top = dCur.offsetTop - textEl.offsetTop;
                var lh = parseFloat(getComputedStyle(textEl).lineHeight) || 30;
                textEl.scrollTop = Math.max(0, top - lh);
            } catch (_) {}
            var s = stroke();
            if (s) {
                var codes = [s.code];
                var keyLabel = TL.label(layout, s.code, false);
                var fname = fingerName(api, TL.finger(s.code));
                var line;
                if (s.shift) {
                    var shiftCode = TL.leftHand(s.code) ? 'ShiftRight' : 'ShiftLeft';
                    codes.push(shiftCode);
                    line = api.tt('hint_shift', { key: keyLabel, finger: fname, shift: api.tt(shiftCode === 'ShiftRight' ? 'shift_right' : 'shift_left') });
                } else if (s.dead) {
                    line = api.tt('hint_dead', { key: keyLabel, finger: fname });
                } else if (s.code === 'Space') {
                    line = api.tt('hint_space');
                } else {
                    line = api.tt('hint_key', { key: keyLabel, finger: fname });
                }
                kb.show(codes);
                hint.textContent = line;
            } else {
                kb.show([]);
                hint.textContent = '';
            }
            paintStats();
        }

        function elapsed() { return started ? (Date.now() - started) / 1000 : 0; }
        function cpmNow() {
            var e = elapsed();
            if (e < 1) return 0;
            return (isKo(layout) ? strokesDone : charsDone) / (e / 60);
        }
        function accNow() { return good + bad ? good / (good + bad) : 1; }
        function paintStats() {
            if (opts.seconds) sTime.textContent = '⏱ ' + fmtTime(started ? Math.max(0, opts.seconds - elapsed()) : opts.seconds);
            else sTime.textContent = api.tt('progress', { n: idx, total: units.length });
            sSpeed.textContent = started ? speedLine(api, layout, cpmNow()) : api.tt('speed_none');
            sAcc.textContent = api.tt('acc', { pct: Math.round(accNow() * 100) });
        }

        function setNotice(kind) {
            if (!kind) { notice.hidden = true; notice.textContent = ''; return; }
            notice.hidden = false;
            notice.textContent = kind === 'caps' ? api.tt('notice_caps')
                : kind === 'touch' ? api.tt('notice_touch')
                : api.tt('notice_layout', { layout: layoutName(api, layout.id) });
        }

        var metro = null;
        function startMetronome(bpm) {
            var stop = false, nextT = 0, timer = null;
            api.audioCtx().then(function (ctx) {
                if (stop) return;
                nextT = ctx.currentTime + 0.05;
                timer = setInterval(function () {
                    while (!stop && nextT < ctx.currentTime + 0.2) {
                        var o = ctx.createOscillator(), g = ctx.createGain();
                        o.frequency.value = 1600;
                        g.gain.setValueAtTime(0.0001, nextT);
                        g.gain.exponentialRampToValueAtTime(0.25, nextT + 0.002);
                        g.gain.exponentialRampToValueAtTime(0.0001, nextT + 0.04);
                        o.connect(g); g.connect(ctx.destination);
                        o.start(nextT); o.stop(nextT + 0.05);
                        nextT += 60 / bpm;
                    }
                }, 50);
            }).catch(function () {});
            return { stop: function () { stop = true; if (timer) clearInterval(timer); } };
        }
        api.onCleanup(function () { if (metro) metro.stop(); });
        function start() {
            if (started) return;
            startNote.hidden = true;
            started = Date.now();
            lastAt = started;
            if (opts.metronome) metro = startMetronome(opts.metronome);
            if (opts.seconds) {
                deadline = started + opts.seconds * 1000;
                ticker = setInterval(function () {
                    if (!api.alive()) return;
                    paintStats();
                    if (Date.now() >= deadline) finish();
                }, 250);
            } else {
                ticker = setInterval(function () { if (api.alive()) paintStats(); }, 500);
            }
        }
        api.onCleanup(function () { if (ticker) clearInterval(ticker); });

        function mark(code, ok) {
            var x = perKey[code] || (perKey[code] = { n: 0, err: 0 });
            x.n++;
            if (!ok) x.err++;
        }

        function advanceStroke(s) {
            var now = Date.now();
            if (lastAt) gaps.push(now - lastAt);
            lastAt = now;
            good++;
            strokesDone++;
            mark(s.code, true);
            sub++;
            errFlag = false;
            if (sub >= cur().strokes.length) {
                charsDone += Array.from(cur().ch).length;
                idx++;
                sub = 0;
                deadArmed = false;
            }
            if (idx >= units.length) {
                if (opts.seconds && opts.regen) {
                    var more = TL.units(opts.regen(), layout);
                    if (more.length) units = units.concat([{ ch: ' ', strokes: [{ code: 'Space', shift: false }] }]).concat(more);
                    else return finish();
                } else {
                    return finish();
                }
            }
            render();
        }

        function miss(s, e, expectedCh) {
            var kind = '';
            if (KS && !layout.byCode && e.key && e.key.length >= 1 && e.key !== 'Dead' && e.key !== 'Process') {
                var caps = !!(e.getModifierState && e.getModifierState('CapsLock'));
                kind = KS.miss(e.key, expectedCh, caps);
            }
            if (kind) { setNotice(kind); return; }
            bad++;
            mark(s.code, false);
            errFlag = true;
            render();
            dCur.classList.add('is-flash');
            setTimeout(function () { try { dCur.classList.remove('is-flash'); } catch (_) {} }, 220);
        }

        function onKey(e) {
            if (ended) return;
            if (!gotKey) { gotKey = true; if (touch) { setNotice(''); api.secondary(null, null); } }
            var u = cur();
            if (!u) return;
            var s = u.strokes[sub];
            if (!started) start();
            if (e.key === 'Backspace' || e.key === 'Enter') return;

            // Пустой e.key — клавиша, давшая больше одного знака (лигатура «لا» в
            // CDP-стенде пришла именно так): судим по физической клавише.
            if (layout.byCode || e.key === 'Process' || e.key === 'Unidentified' || e.key === '') {
                // По физической клавише: корейский (IME) и всё, где символа нет.
                var shiftNeeded = !!s.shift;
                var k = layout.keys[s.code] || ['', ''];
                var shiftFree = k[0] === k[1];
                if (e.code === s.code && (shiftNeeded ? e.shiftKey : (shiftFree || !e.shiftKey))) { setNotice(''); advanceStroke(s); }
                else if (e.code === 'Space' || layout.keys[e.code]) miss(s, e, u.ch);
                return;
            }
            if (e.key === 'Dead') {
                if (s.dead && e.code === s.code) { setNotice(''); deadArmed = true; advanceStroke(s); }
                else miss(s, e, u.ch);
                return;
            }
            if (u.altMode) {
                // «لا» начат клавишей ل — дальше сверяем клавиши по коду.
                if (e.code === s.code) { setNotice(''); advanceStroke(s); } else miss(s, e, u.ch);
                return;
            }
            var want = u.ch;
            var got = e.key;
            if (layout.id === 'arabic' && AR_DIGITS[got]) got = AR_DIGITS[got];
            var ok = got === want || (KS ? KS.matches(got, want) : false);
            if (!ok && got.length > 1 && want.length > 1 && got === want) ok = true;
            // «لا» своей клавишей (B): браузер может назвать лигатуру по-разному — решает клавиша.
            if (!ok && u.alt && sub === 0 && e.code === s.code && !!e.shiftKey === !!s.shift) ok = true;
            // «لا» набран двумя клавишами: ل, затем ا.
            if (!ok && u.alt && sub === 0 && e.code === u.alt[0].code) {
                u.strokes = u.alt; u.alt = null; u.altMode = true; setNotice(''); advanceStroke(u.strokes[0]); return;
            }
            // Мёртвая клавиша уже нажата, а браузер не сложил букву (нет поля ввода):
            // база на своей клавише — это верная буква.
            if (!ok && deadArmed && s && !s.dead && e.code === s.code) ok = true;
            if (ok) {
                setNotice('');
                if (s.dead && sub === 0) { advanceStroke(s); s = cur() && cur().strokes[sub]; if (!s) return; }
                // Символ целиком — все удары единицы засчитаны одной клавишей.
                while (cur() === u && sub < u.strokes.length) { var st = u.strokes[sub]; advanceStroke(st); if (ended) return; }
                return;
            }
            miss(s, e, want);
        }

        function finish() {
            if (ended) return;
            ended = true;
            if (ticker) { clearInterval(ticker); ticker = null; }
            if (metro) { metro.stop(); metro = null; }
            off();
            var secs = Math.max(1, opts.seconds ? Math.min(opts.seconds, elapsed()) : elapsed());
            var cpm = (isKo(layout) ? strokesDone : charsDone) / (secs / 60);
            var acc = accNow();
            // Ученику — слабые клавиши этого шага; в копилку — все.
            var all = statsGet(api);
            var worst = [];
            for (var code in perKey) {
                if (!Object.prototype.hasOwnProperty.call(perKey, code)) continue;
                var p = perKey[code];
                var a = all[code] || { n: 0, err: 0 };
                a.n += p.n; a.err += p.err;
                all[code] = a;
                if (p.err && code !== 'Space') worst.push({ code: code, err: p.err });
            }
            api.store.set('keyStats', all);
            worst.sort(function (x, y) { return y.err - x.err; });
            var minAcc = opts.minAcc || 0.9;
            var minCpm = opts.minCpm || 0;
            var okAcc = acc >= minAcc - 1e-9, okCpm = !minCpm || cpm >= minCpm - 1e-9;
            var correct = okAcc && okCpm;
            var score = correct ? 1 : 0.5 * Math.min(1, acc / minAcc) * (minCpm ? Math.min(1, cpm / minCpm) : 1);
            var lines = [api.tt('result', { speed: speedLine(api, layout, cpm), pct: Math.round(acc * 100) })];
            if (worst.length) lines.push(api.tt('result_weak', { keys: worst.slice(0, 4).map(function (w) { return TL.label(layout, w.code, false); }).join(api.locale === 'ar' ? '، ' : ', ') }));
            if (gaps.length > 12) {
                var m = gaps.reduce(function (s2, x) { return s2 + x; }, 0) / gaps.length;
                var sd = Math.sqrt(gaps.reduce(function (s2, x) { return s2 + (x - m) * (x - m); }, 0) / gaps.length);
                var even = Math.max(0, Math.min(100, Math.round(100 - (sd / m) * 100)));
                lines.push(api.tt('result_even', { pct: even }));
            }
            if (!okAcc) lines.push(api.tt('need_acc', { pct: Math.round(minAcc * 100) }));
            if (!okCpm) lines.push(api.tt('need_speed', { speed: speedLine(api, layout, minCpm) }));
            if (t.explain) lines.push(t.explain);
            api.answer({ correct: correct, score: score, explain: lines.join('\n') });
        }

        var off = captureKeys(api, onKey);
        if (touch) {
            setNotice('touch');
            startNote.hidden = true;
            api.secondary(api.tt('skip_no_kbd'), function () {
                off();
                if (api.exam) api.answer({ correct: false, score: 0, explain: api.tt('exam_needs_kbd') });
                else api.skip(api.tt('skipped_no_kbd'));
            });
        }
        try { if (document.activeElement && host.contains(document.activeElement) === false && document.activeElement !== document.body) document.activeElement.blur(); } catch (_) {}
        try { textEl.focus({ preventScroll: true }); } catch (_) {}
        render();
        return { destroy: function () { if (ticker) clearInterval(ticker); off(); } };
    }

    /* ── «Раскладка: … · сменить» ─────────────────────────────────── */
    function layoutBar(host, api, onChange) {
        var o = TL.forLocale(api.locale);
        var id = layoutId(api);
        var row = api.el('p', 'ty-layout');
        row.appendChild(document.createTextNode(api.tt('layout_is', { layout: layoutName(api, id) }) + ' '));
        if (o.options.length > 1) {
            var b = api.el('button', 'ty-link', api.tt('layout_change'));
            b.type = 'button';
            b.addEventListener('click', function () {
                var i = o.options.indexOf(id);
                var next = o.options[(i + 1) % o.options.length];
                api.store.set('layout', next);
                onChange(next);
            });
            row.appendChild(b);
        }
        host.appendChild(row);
        return row;
    }

    function prompt(host, api, step, layout) {
        var t = step.t || {};
        // В тексте шага клавиши записаны подписями раскладки по умолчанию языка
        // (так их видит и список «где споткнулись» в конце урока); другой раскладке —
        // её подписи на том же месте.
        var focus = step.focus || [];
        var keysOf = function (lay) { return focus.map(function (c) { return TL.label(lay, c, false); }).join(' '); };
        var title = t.title || '';
        var def = TL.get(TL.forLocale(api.locale).def);
        if (focus.length && def && def.id !== layout.id) {
            var was = keysOf(def);
            if (was && title.indexOf(was) >= 0) title = title.replace(was, keysOf(layout));
        }
        var vars = { keys: keysOf(layout), sec: step.seconds || 0 };
        if (title) host.appendChild(api.el('h3', null, api.fmt(title, vars)));
        if (t.prompt) host.appendChild(api.richEl('p', 'crs-prompt', api.fmt(t.prompt, vars)));
        if (t.body) api.body(host, t.body);
    }

    /* ── шаги ─────────────────────────────────────────────────────── */
    function typingStep(defaults) {
        return {
            reviewable: false,
            mount: function (host, step, api) {
                var ctl = null, attempt = api.store.get('attempt:' + step._lesson + '/' + step.id, 0) + 1;
                api.store.set('attempt:' + step._lesson + '/' + step.id, attempt);
                function draw() {
                    if (ctl) { try { ctl.destroy(); } catch (_) {} ctl = null; }
                    host.innerHTML = '';
                    var layout = TL.get(layoutId(api));
                    prompt(host, api, step, layout);
                    layoutBar(host, api, function () { draw(); });
                    var wait = api.el('p', 'crs-hint', api.tt('loading_words'));
                    host.appendChild(wait);
                    loadWords().then(function (words) {
                        if (!api.alive()) return;
                        wait.remove();
                        var mode = step.mode || defaults.mode;
                        var s2 = Object.assign({}, step, { mode: mode, length: step.length || defaults.length });
                        var text = buildText(s2, api, layout, words, attempt);
                        if (!text) { host.appendChild(api.el('p', 'crs-hint', api.tt('no_text'))); api.primary(api.t('next'), function () { api.skip(); }); return; }
                        var regenN = 0;
                        ctl = runTyping(host, step, api, layout, {
                            text: text,
                            seconds: step.seconds || 0,
                            minAcc: step.minAcc || defaults.minAcc,
                            minCpm: step.minCpm || 0,
                            blind: step.blind != null ? !!step.blind : (defaults.blindToggle ? false : null),
                            focus: step.focus || [],
                            metronome: step.metronome || 0,
                            regen: function () { regenN++; return buildText(Object.assign({}, s2, { id: s2.id + '~' + regenN }), api, layout, words, attempt); }
                        });
                    });
                }
                draw();
                return { destroy: function () { if (ctl) { try { ctl.destroy(); } catch (_) {} } } };
            }
        };
    }

    K.step('type-keys', typingStep({ mode: 'keys', length: 48, minAcc: 0.9 }));
    K.step('type-drill', typingStep({ mode: 'words', length: 90, minAcc: 0.9, blindToggle: true }));
    K.step('type-text', typingStep({ mode: 'text', length: 0, minAcc: 0.92, blindToggle: true }));
    K.step('type-test', typingStep({ mode: 'words', length: 400, minAcc: 0.92, blindToggle: true }));

    /* Каким пальцем нажимают эту клавишу. */
    K.step('type-finger', {
        reviewable: false,
        mount: function (host, step, api) {
            var layout = TL.get(layoutId(api));
            var t = step.t || {};
            if (t.prompt) host.appendChild(api.richEl('p', 'crs-prompt', t.prompt));
            var codes = (step.keys || []).filter(function (c) { return layout.keys[c]; });
            var r = rng(step._lesson + '/' + step.id + '/' + Date.now());
            var n = Math.min(step.count || 6, 12);
            var order = [];
            var focus = (step.focus || []).filter(function (c) { return layout.keys[c]; });
            for (var i = 0; i < n; i++) order.push(i < focus.length ? focus[i] : pick(codes, r));
            order = api.shuffle(order);
            var card = api.el('div', 'ty-fq');
            var big = api.el('div', 'ty-fq-key');
            var count = api.el('p', 'crs-hint');
            var hands = api.el('div', 'ty-hands');
            var why = api.el('p', 'ty-fq-why');
            card.appendChild(count); card.appendChild(big); card.appendChild(hands); card.appendChild(why);
            host.appendChild(card);
            var i2 = 0, right = 0, busy = false, wrong = [];
            var btns = {};
            [['LP', 'LR', 'LM', 'LI'], ['RI', 'RM', 'RR', 'RP']].forEach(function (hand, hi) {
                var h = api.el('div', 'ty-hand');
                h.appendChild(api.el('span', 'ty-hand-k', api.tt(hi ? 'hand_right' : 'hand_left')));
                var row = api.el('div', 'ty-hand-row');
                hand.forEach(function (f) {
                    var b = api.el('button', 'crs-chip ty-fbtn f-' + f, api.tt('fshort_' + f));
                    b.type = 'button';
                    b.setAttribute('aria-label', fingerName(api, f));
                    b.addEventListener('click', function () { answer(f); });
                    btns[f] = b;
                    row.appendChild(b);
                });
                h.appendChild(row);
                hands.appendChild(h);
            });
            function show() {
                busy = false;
                why.textContent = '';
                count.textContent = api.tt('fq_count', { n: i2 + 1, total: order.length });
                big.textContent = TL.label(layout, order[i2], false);
                Object.keys(btns).forEach(function (f) { btns[f].classList.remove('is-right', 'is-wrong'); btns[f].disabled = false; });
            }
            function answer(f) {
                if (busy) return;
                busy = true;
                var code = order[i2];
                var want = TL.finger(code);
                var ok = f === want;
                if (ok) right++; else wrong.push(TL.label(layout, code, false) + ' — ' + fingerName(api, want));
                btns[f].classList.add(ok ? 'is-right' : 'is-wrong');
                if (!ok) btns[want].classList.add('is-right');
                why.textContent = ok ? api.t('fb_right') : api.tt('fq_is', { finger: fingerName(api, want) });
                setTimeout(function () {
                    if (!api.alive()) return;
                    i2++;
                    if (i2 < order.length) show();
                    else {
                        var score = right / order.length;
                        api.answer({ correct: score >= 0.8, score: score, reveal: wrong.length ? wrong.join('\n') : null, explain: t.explain || null });
                    }
                }, ok ? 500 : 1300);
            }
            show();
        }
    });

    /* Раскладка и проверка клавиатуры перед первым уроком. */
    K.step('type-setup', {
        graded: false,
        mount: function (host, step, api) {
            var t = step.t || {};
            var o = TL.forLocale(api.locale);
            function draw() {
                host.innerHTML = '';
                var id = layoutId(api);
                var layout = TL.get(id);
                if (t.title) host.appendChild(api.el('h3', null, t.title));
                api.body(host, t.body || []);
                if (o.options.length > 1) {
                    host.appendChild(api.el('p', 'crs-prompt', api.tt('setup_choose')));
                    var chips = api.el('div', 'crs-chips');
                    o.options.forEach(function (opt) {
                        var c = api.el('button', 'crs-chip' + (opt === id ? ' is-sel' : ''), layoutName(api, opt));
                        c.type = 'button';
                        c.setAttribute('aria-pressed', opt === id ? 'true' : 'false');
                        c.addEventListener('click', function () { api.store.set('layout', opt); draw(); });
                        chips.appendChild(c);
                    });
                    host.appendChild(chips);
                } else {
                    host.appendChild(api.el('p', 'ty-layout', api.tt('layout_is', { layout: layoutName(api, id) })));
                }
                var sug = api.el('p', 'ty-notice');
                sug.hidden = true;
                host.appendChild(sug);
                TL.detect().then(function (d) {
                    if (!api.alive() || !d || d === id) return;
                    if (o.options.indexOf(d) >= 0) {
                        sug.hidden = false;
                        sug.textContent = api.tt('setup_detected', { layout: layoutName(api, d) }) + ' ';
                        var b = api.el('button', 'ty-link', api.tt('setup_use'));
                        b.type = 'button';
                        b.addEventListener('click', function () { api.store.set('layout', d); draw(); });
                        sug.appendChild(b);
                    } else if (TL.get(d).script !== layout.script) {
                        sug.hidden = false;
                        sug.textContent = api.tt('setup_switch', { layout: layoutName(api, id) });
                    }
                });
                var fig = api.el('div', 'crs-fig ty-fig');
                var kb = keyboard(api, layout, { focus: ['KeyF', 'KeyJ'] });
                fig.appendChild(kb.el);
                fig.appendChild(legend(api));
                host.appendChild(fig);
                var f = TL.label(layout, 'KeyF', false), j = TL.label(layout, 'KeyJ', false);
                var check = api.el('p', 'crs-prompt', api.tt('setup_press', { f: f, j: j }));
                host.appendChild(check);
                var status = api.el('p', 'ty-hint', '');
                status.setAttribute('aria-live', 'polite');
                host.appendChild(status);
                var seen = {};
                if (coarse()) {
                    status.textContent = api.tt('notice_touch');
                }
                var off = captureKeys(api, function (e) {
                    if (e.code === 'KeyF' || e.code === 'KeyJ') {
                        seen[e.code] = 1;
                        var ch = e.key;
                        var want = layout.keys[e.code][0];
                        var wrongScript = !layout.byCode && KS && ch && ch.length === 1 && KS.scriptOf(ch) && KS.scriptOf(ch) !== KS.scriptOf(want);
                        if (wrongScript) { status.textContent = api.tt('notice_layout', { layout: layoutName(api, id) }); return; }
                        kb.show(Object.keys(seen));
                        if (seen.KeyF && seen.KeyJ) { status.textContent = api.tt('setup_ok'); off(); }
                        else status.textContent = api.tt('setup_one_more');
                    }
                });
                api.primary(api.t('next'), function () { off(); api.answer({ correct: null }); });
            }
            draw();
        }
    });
})();
